import { memo } from 'react';
import { Label, LabelProps } from '../label';

interface Props extends LabelProps {}

export const TabLabel = memo(({ ref, ...labelProps }: Props) => {
  return (
    <Label
      size="xxxsmall"
      {...labelProps}
      className={'TabLabel'}
      sx={{ width: 'auto' }}
    />
  );
});

TabLabel.displayName = 'TabLabel';
